<template>
  <div class="basicInformation">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.factoryReport.General_Information') }}
    </div>
    <div class="basicInf-con">
      <ul>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Client_Name') }}：</span
          >
          <span>{{ factoryDetails.freportClientname }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Factory_Name') }}：</span
          >
          <span>{{ factoryDetails.freportVendorname }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Business_License_Address') }}：</span
          >
          <span>{{ factoryDetails.freportRegisteraddress }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Actual_Factory_Address') }}：</span
          >
          <span
            >{{
              factoryDetails.freportActualaddress == 1
                ? this.$tc('lang.factoryReport.Conform')
                : this.$tc('lang.factoryReport.Not_Conform')
            }}
          </span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Factory_Legal_Person') }}：</span
          >
          <span>{{ factoryDetails.freportLegalperson }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Factory_Ownership') }}：</span
          >
          <span>{{ factoryDetails.freportOwnership }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Factory_Established_At') }}：</span
          >
          <span>{{
            factoryDetails.freportCreatetime != null &&
            factoryDetails.freportCreatetime != ''
              ? $moment(factoryDetails.freportCreatetime).format(
                  'YYYY-MM-DD HH:mm',
                )
              : ''
          }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Business_License_valid_till') }}：</span
          >
          <span>{{ factoryDetails.freportValidity }}</span>
        </li>
      </ul>
      <ul>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Business_License_Number') }}：</span
          >
          <span>{{ factoryDetails.freportLicensenumber }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Registered_Capital') }}：</span
          >
          <span>{{ factoryDetails.freportRegisteredcapital }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Annual_Audit') }}：</span
          >
          <span>{{
            factoryDetails.freportAnnualaudit == 1
              ? $tc('lang.factoryReport.Conform')
              : $tc('lang.factoryReport.Not_Conform')
          }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Main_Product') }}：</span
          >
          <span>{{ factoryDetails.freportMainproduct }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Annual_Output') }}：</span
          >
          <span>{{ factoryDetails.freportAnnualoutput }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Website') }}：</span
          >
          <span>{{ factoryDetails.freportWebsite }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Main_Market') }}：</span
          >
          <span>{{ factoryDetails.freportMainmarket }}</span>
        </li>
        <li>
          <span class="basicInf-p1"
            >{{ $tc('lang.factoryReport.Service_data') }}：</span
          >
          <span>{{ factoryDetails.freportInspectdate }}</span>
        </li>
      </ul>
    </div>
    <div>
      <div v-if="basicImg == undefined"></div>
      <div v-else-if="basicImg.length == 0"></div>
      <div v-else>
        <div class="desOfGoods-con">
          <span>{{ $tc('lang.factoryReport.Business_License') }}</span>
          <div class="img">
            <show-img
              :data="basicImg.freportBusinesslicense"
              :otherData="{
                mediaName: '营业执照',
                mediaType: 3,
                personId: '',
                orderId: '',
                reportId: '',
                mediaDesc: 'freportBusinesslicense',
              }"
              :id="id"
            ></show-img>
          </div>
        </div>

        <div class="desOfGoods-con">
          <span>{{
            $tc('lang.factoryReport.Factory_Property_Ownership_Certificate')
          }}</span>
          <div class="img">
            <show-img
              :data="basicImg.freportCertificate"
              :otherData="{
                mediaName: '房产证文件',
                mediaType: 3,
                personId: '',
                orderId: '',
                reportId: '',
                mediaDesc: 'freportCertificate',
              }"
              :id="id"
            ></show-img>
          </div>
        </div>
        <div class="desOfGoods-con">
          <span>{{ $tc('lang.factoryReport.Tenancy_Agreements') }}</span>
          <div class="img">
            <show-img
              :data="basicImg.freportAgreements"
              :otherData="{
                mediaName: '租赁合同',
                mediaType: 3,
                personId: '',
                orderId: '',
                reportId: '',
                mediaDesc: 'freportAgreements',
              }"
              :id="id"
            ></show-img>
          </div>
        </div>
        <div class="desOfGoods-con">
          <span>{{
            $tc('lang.factoryReport.ID_Card_Of_The_Legal_Person')
          }}</span>
          <div class="img">
            <show-img
              :data="basicImg.freportIdcard"
              :otherData="{
                mediaName: '法人身份证（正反）',
                mediaType: 3,
                personId: '',
                orderId: '',
                reportId: '',
                mediaDesc: 'freportIdcard',
              }"
              :id="id"
            ></show-img>
          </div>
        </div>
        <div class="desOfGoods-con">
          <span>{{ $tc('lang.factoryReport.Company_Awards') }}</span>
          <div class="img">
            <show-img
              :data="basicImg.freportCompanyawards"
              :otherData="{
                mediaName: '企业荣誉证书',
                mediaType: 3,
                personId: '',
                orderId: '',
                reportId: '',
                mediaDesc: 'freportCompanyawards',
              }"
              :id="id"
            ></show-img>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      title="修改基本资料"
      :visible="visible"
      v-if="visible"
      :maskClosable="false"
      wrapClassName="reportModal"
      @ok="handleSubmit"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      width="850px"
    >
      <a-form :form="form" @submit="handleSubmit" class="basicinf-updataForm">
        <a-form-item
          label="委托方名称"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input disabled v-decorator="['freportClientname']" />
        </a-form-item>
        <a-form-item
          label="工商营业执照号"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['freportLicensenumber']"></a-input>
        </a-form-item>
        <a-form-item
          label="工厂名称"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input disabled v-decorator="['freportVendorname']"></a-input>
        </a-form-item>
        <a-form-item
          label="注册资本"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['freportRegisteredcapital']"></a-input>
        </a-form-item>
        <a-form-item
          label="工厂注册地址"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['freportRegisteraddress']"></a-input>
        </a-form-item>
        <a-form-item
          label="年审情况"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-radio-group v-decorator="['freportAnnualaudit']">
            <a-radio value="1">符合</a-radio>
            <a-radio value="2">不符合</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="工厂实际地址"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-radio-group v-decorator="['freportActualaddress']">
            <a-radio value="1">符合</a-radio>
            <a-radio value="2">不符合</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="主营产品"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['freportMainproduct']"></a-input>
        </a-form-item>
        <a-form-item
          label="法人姓名"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['freportLegalperson']"></a-input>
        </a-form-item>
        <a-form-item
          label="年产值"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['freportAnnualoutput']"></a-input>
        </a-form-item>
        <a-form-item
          label="工厂所有权"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-select v-decorator="['freportOwnership']" style="width: 100%">
            <a-select-option value="自有产权">自有产权</a-select-option>
            <a-select-option value="租用">租用</a-select-option>
            <a-select-option value="政府拨款">政府拨款</a-select-option>
            <a-select-option value="其他">其他</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="网址"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['freportWebsite']"></a-input>
        </a-form-item>
        <a-form-item
          label="工厂成立时间"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-date-picker
            style="width:100%"
            :showTime="{ format: 'HH:mm' }"
            format="YYYY-MM-DD HH:mm"
            v-decorator="['freportCreatetime']"
          />
        </a-form-item>
        <a-form-item
          label="工厂主要市场"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-select
            v-decorator="['freportMainmarket']"
            mode="multiple"
            style="width: 100%"
            :maxTagCount="2"
          >
            <a-select-option value="北美">北美</a-select-option>
            <a-select-option value="西欧">西欧</a-select-option>
            <a-select-option value="东欧">东欧</a-select-option>
            <a-select-option value="亚洲">亚洲</a-select-option>
            <a-select-option value="中东">中东</a-select-option>
            <a-select-option value="南美">南美</a-select-option>
            <a-select-option value="中国">中国</a-select-option>
            <a-select-option value="非洲">非洲</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="工厂执照有效期"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-input v-decorator="['freportValidity']"></a-input>
        </a-form-item>
        <a-form-item
          label="服务时间"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-date-picker
            style="width:100%"
            :showTime="{ format: 'HH:mm' }"
            format="YYYY-MM-DD HH:mm"
            v-decorator="['freportInspectdate']"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import showImg from './showImg';
export default {
  name: 'basicInformation',
  data() {
    return {
      id: this.$route.query.id,
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),

      // loading: false,
      imageUrl: '',
    };
  },
  components: {
    showImg,
  },
  computed: {
    factoryDetails: {
      get() {
        return this.$store.state.report.factoryDetails;
      },
      set(val) {
        this.$store.commit('report/save', { factoryDetails: val });
      },
    },
    basicImg: {
      get() {
        return this.$store.state.report.factoryImgList.basicImg
          ? JSON.parse(
              JSON.stringify(this.$store.state.report.factoryImgList.basicImg),
            )
          : {};
      },
    },
  },
  methods: {
    //打开修改弹窗
    showModal() {
      this.visible = true;
      setTimeout(() => {
        this.form.setFieldsValue({
          freportClientname: this.factoryDetails.freportClientname,
          freportVendorname: this.factoryDetails.freportVendorname,
          freportRegisteraddress: this.factoryDetails.freportRegisteraddress,
          freportActualaddress: this.factoryDetails.freportActualaddress,

          orderId: this.factoryDetails.orderId,

          freportMainmarket: this.factoryDetails.freportMainmarket.split(','),
          freportLegalperson: this.factoryDetails.freportLegalperson,
          freportOwnership: this.factoryDetails.freportOwnership,
          freportValidity: this.factoryDetails.freportValidity,
          freportLicensenumber: this.factoryDetails.freportLicensenumber,
          freportRegisteredcapital: this.factoryDetails
            .freportRegisteredcapital,
          freportAnnualaudit: this.factoryDetails.freportAnnualaudit,
          freportMainproduct: this.factoryDetails.freportMainproduct,
          freportAnnualoutput: this.factoryDetails.freportAnnualoutput,
          freportWebsite: this.factoryDetails.freportWebsite,

          freportCreatetime: this.factoryDetails.freportCreatetime
            ? this.$moment(this.factoryDetails.freportCreatetime)
            : null,
          freportInspectdate: this.factoryDetails.freportInspectdate
            ? this.$moment(this.factoryDetails.freportInspectdate)
            : null,
        });
      }, 0);
    },
    handleSubmit(e) {
      this.confirmLoading = true;
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http
            .post('/hzwmj/workorder-factoryreport/saveOrUpdateFactoryreport', {
              freportId: this.factoryDetails.freportId,
              modelType: '1',

              freportClientname: values.freportClientname,
              freportVendorname: values.freportVendorname,
              freportRegisteraddress: values.freportRegisteraddress,
              freportActualaddress: values.freportActualaddress,

              freportMainmarket: values.freportMainmarket.join(','),
              freportLegalperson: values.freportLegalperson,
              freportOwnership: values.freportOwnership,
              freportValidity: values.freportValidity,
              freportLicensenumber: values.freportLicensenumber,
              freportRegisteredcapital: values.freportRegisteredcapital,
              freportAnnualaudit: values.freportAnnualaudit,
              freportMainproduct: values.freportMainproduct,
              freportAnnualoutput: values.freportAnnualoutput,
              freportWebsite: values.freportWebsite,

              freportCreatetime:
                values.freportCreatetime == null
                  ? ''
                  : values.freportCreatetime.format('YYYY-MM-DD HH:mm'), //注册时间
              freportInspectdate:
                values.freportInspectdate == null
                  ? ''
                  : values.freportInspectdate.format('YYYY-MM-DD HH:mm'), //注册时间
            })
            .then(data => {
              if (data) {
                this.$message.success('保存信息成功');
                // this.factoryDetails = data;
                this.getDetail();

                this.visible = false;
                this.confirmLoading = false;
              } else {
                this.$message.error('保存信息失败');
                this.confirmLoading = false;
              }
            })
            .catch(() => {
              this.$message.error('保存信息失败');
              this.confirmLoading = false;
            });
        }
      });
    },
    getDetail() {
      this.$http
        .post('/hzwmj/workorder-factoryreport/seachFactoryreport', {
          id: this.id,
        })
        .then(data => {
          if (data) {
            this.factoryDetails = data;
          } else {
            this.factoryDetails = {};
          }
        })
        .catch(() => {
          this.factoryDetails = {};
        });
    },
    handleCancel() {
      this.visible = false;
    },

    saveImg() {
      let fileList = [];
      let fileList1 = [];
      let fileList2 = [];
      let fileList3 = [];
      let fileList4 = [];
      this.basicImg.freportBusinesslicense.forEach(item => {
        fileList.push(item.id);
      });
      this.basicImg.freportCertificate.forEach(item => {
        fileList1.push(item.id);
      });
      this.basicImg.freportAgreements.forEach(item => {
        fileList2.push(item.id);
      });
      this.basicImg.freportIdcard.forEach(item => {
        fileList3.push(item.id);
      });
      this.basicImg.freportCompanyawards.forEach(item => {
        fileList4.push(item.id);
      });
      var postData = {
        freportId: this.factoryDetails.freportId,
        freportMedianame: '基本信息',
        freportMediatype: '1',
        modelType: '1',

        freportBusinesslicense: fileList.join(','),
        freportCertificate: fileList1.join(','),
        freportAgreements: fileList2.join(','),
        freportIdcard: fileList3.join(','),
        freportCompanyawards: fileList4.join(','),
      };
      // postData[type] = fileList.join(',');
      this.$http
        .post('/hzwmj/factory-media/saveOrUpdateFactoryMedia', postData)
        .then(data => {
          if (data) {
            // this.visible = false;
            this.$message.success('保存成功');
            this.$store.dispatch(
              'report/getfactoryImg',
              this.factoryDetails.freportId,
            );
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.basicInformation {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
    }
  }
  .basicInf-con {
    display: flex;
    .basicInf-p1 {
      display: inline-block;
      width: 130px;
    }
    > ul {
      width: 40%;
      li {
        line-height: 40px;
      }
    }
    > div {
      width: 20%;
      text-align: center;
      // img {
      //   width: 60%;
      //   margin: 50px 0 10px 0;
      // }
    }
  }
  .prodeImg > div {
    display: inline-block;
    width: 160px;
    height: 120px;
    border: 1px solid rgb(202, 202, 202);
    text-align: center;
    margin: 10px;
    overflow: hidden;
    margin-top: 30px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.basicinf-updataForm {
  .ant-form-item {
    width: 50%;
    display: inline-block;
    .ant-form-item-label {
      text-align: left;
    }
  }
}
</style>
